import { Data, Effect } from "effect"
import { blobToBase64, blobToJson } from "../blob-to-base64"
import type { FriendlyError } from "../friendly-error"

export const ImageBitmapEffect = Effect.fn("ImageBitmapEffect")((blob: Blob) =>
    Effect.tryPromise({
        try: () => createImageBitmap(blob),
        catch: (error) =>
            new ImageBitmapError({ message: "Failed to create ImageBitmap", originalError: error }),
    }),
)

export class ImageBitmapError<T>
    extends Data.TaggedError("ImageBitmapError")<{
        message: string
        originalError?: T
    }>
    implements FriendlyError
{
    get friendly() {
        return "Something went wrong during an image bitmap conversion!"
    }
}

export const Base64Effect = Effect.fn("Base64Effect")((blob: Blob) =>
    Effect.tryPromise({
        try: () => blobToBase64(blob),
        catch: (error) =>
            new Base64Error({ message: "Failed to create Blob", originalError: error }),
    }),
)

export class Base64Error<T>
    extends Data.TaggedError("Base64Error")<{
        message: string
        originalError?: T
    }>
    implements FriendlyError
{
    get friendly() {
        return "Something went wrong during a conversion process!"
    }
}

export const BlobEffect = Effect.fn("BlobEffect")((arr: readonly Uint8Array[], mime: string) =>
    Effect.try({
        try: () => new Blob(arr as Uint8Array[], { type: mime }),
        catch: (error) => new BlobError({ message: "Failed to create Blob", originalError: error }),
    }),
)

export class BlobError<T>
    extends Data.TaggedError("BlobError")<{
        message: string
        originalError?: T
    }>
    implements FriendlyError
{
    get friendly() {
        return "Something went wrong during a conversion process!"
    }
}

export const JsonEffect = Effect.fn("JsonEffect")((blob: Blob) =>
    Effect.tryPromise({
        try: () => blobToJson(blob),
        catch: (error) => new JsonError({ message: "Failed to parse JSON", originalError: error }),
    }),
)

export class JsonError<T>
    extends Data.TaggedError("JsonError")<{
        message: string
        originalError?: T
    }>
    implements FriendlyError
{
    get friendly() {
        return "Something went wrong during a conversion process!"
    }
}
